import { createContext } from 'react';

type InternalTabsState<T extends string = string> = {
  onTabMouseEnter: (value: T) => void;
  onTabMouseLeave: (value: T) => void;
};

export const InternalTabsContext = createContext<InternalTabsState<any>>(
  undefined as never
);
